import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useParams } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';
import { useQueryParam } from '@/hooks/useQueryParam';
import { useRedirectOnRemovedEntity } from '@/hooks/useRedirectOnRemovedEntity';
import { useSidebarNoteStore } from '@/stores/local/sidebar/SidebarNoteStore';

import ConfirmPopup from '../../common/ConfirmPopup';
import NotesList from '../NotesList';

import s from './NotesTabContent.module.scss';

const NotesTabContent: React.FC = () => {
  const { id, noteId } = useParams();

  const { notes } = useSidebarNoteStore();
  const documentIdFilter = useQueryParam('document_id');

  useRedirectOnRemovedEntity(notes, noteId, id ? ROUTES.organization.notebook.notes.create(id) : null);

  React.useEffect(() => {
    notes.fetchNotes(documentIdFilter);
  }, [documentIdFilter, id, notes]);

  return (
    <div className={s.root}>
      <NotesList />
      <ConfirmPopup
        meta={notes.popupMeta}
        store={notes.removePopup}
        title="Удалить заметку"
        description="Вы действительно хотите удалить заметку? Восстановить заметку будет невозможно."
      />
    </div>
  );
};

export default observer(NotesTabContent);
